import { ContactUsService } from './../../services/contact-us.service';
import { ContactUsComponent } from './../contact-us/contact-us.component';
import { Component, OnInit } from '@angular/core';
import { ColumnTable } from 'src/app/models/column-table/column-table.component';
import { Users } from 'src/app/models/users';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActionModel } from 'src/app/models/table-action-model';
import { ConfirmDialogComponent } from 'src/app/base-components/dialogs/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-contact-us-list',
  templateUrl: './contact-us-list.component.html',
  styleUrls: ['./contact-us-list.component.scss']
})
export class ContactUsListComponent implements OnInit {
  columns: ColumnTable[];
  userTotal = 100;
  userData = [];
  selectAction: any;
  actions = [];
  userSortBy = 'firstName';
  userOrderBy = 'asc';
  isShowResult = false;
  userLimit = 10;
  userPageIndex = 1;
  modalRef: any;
  userDetail: Users;
  rawData: any;
  isLoading = true;

  constructor(
    private router: Router,
    private userService: UserService,
    private toastr: ToastrService,
    private modal: NgbActiveModal,
    private modalService: NgbModal,
    private contactUsService: ContactUsService
  ) {

  }

  ngOnInit() {
    sessionStorage.setItem('isHome', 'false');
    sessionStorage.setItem('isRedirectSearchFromFile', 'false');
    
    this.columns = [
      new ColumnTable('', '', '', 'checkbox', false),
      new ColumnTable('Name', 'firstName', 'col-2', 'name', true, 'firstName'),
      new ColumnTable('Phone', 'phone', 'col-1', 'text', true, 'phone'),
      new ColumnTable('Email', 'email', 'col-2', 'text', true, 'email'),
      new ColumnTable('Message', 'message', 'col-2', 'message', true, 'message'),
      new ColumnTable('Create date', 'createdAt', 'col-2', 'createDate', true, 'createdAt'),

    ];

    this.actions.push(new ActionModel({
      callBack: (data) => this.read(data),
      type: 'read'
    }));
    this.actions.push(new ActionModel({
      callBack: (data) => this.unRead(data),
      type: 'unread'
    }));
    this.actions.push(new ActionModel({
      callBack: (data) => this.delete(data),
      type: 'delete'
    }));

    this.contactUsService.getAll().subscribe((res: []) => {
      this.rawData = res;
      this.userData = res;
      this.userTotal = this.userData.length;
      this.isLoading = false;
    });
  }
  delete(data: any) {
    const modalRef = this.modalService.open(ConfirmDialogComponent);
    modalRef.result.then((result) => {
      if (result) {
        this.contactUsService.delete(data.id).subscribe(x => {
          this.contactUsService.getAll().subscribe((res: []) => {
            this.toastr.success('Delete Success');
            this.userData = res;
            this.rawData = res;
            this.userTotal = this.userData.length;
          });
        });
      }
    }, (reason) => {
    });
  }
  unRead(data: any) {
    data.isRead = false;
    this.contactUsService.update(data).subscribe(x => {
      this.contactUsService.getAll().subscribe((res: []) => {
        this.rawData = res;
        this.userData = res;
        this.userTotal = this.userData.length;
      });
    });
  }
  read(data: any) {
    data.IsRead = true;
    this.contactUsService.update(data).subscribe(x => {
      this.contactUsService.getAll().subscribe((res: []) => {
        this.rawData = res;
        this.userData = res;
        this.userTotal = this.userData.length;
      });
    });
  }
  onTableOwnPageChange(event) {
    this.userLimit = event.pageSize;
    this.userPageIndex = event.pageIndex;
  }

  onSortChange(event) {
    const col = event.sortBy;
    if (col === 'firstName') {
      this.userData = this.userData.sort((a, b) => {
        if (a.firstName + a.lastName < b.firstName + a.lastName) {
          return event.orderBy === 'asc' ? -1 : 1;
        } else if (a.firstName + a.lastName > b.firstName + a.lastName)  {
          return event.orderBy === 'asc' ? 1 : -1;
        } else {
          return 0;
        }
      });
    } else if (col === 'phone') {
      this.userData = this.userData.sort((a, b) => {
        if (a.phone < b.phone) {
          return event.orderBy === 'asc' ? -1 : 1;
        } else if (a.phone > b.phone)  {
          return event.orderBy === 'asc' ? 1 : -1;
        } else {
          return 0;
        }
      });
    } else if (col === 'email') {
      this.userData = this.userData.sort((a, b) => {
        if (a.email < b.email) {
          return event.orderBy === 'asc' ? -1 : 1;
        } else if (a.email > b.email)  {
          return event.orderBy === 'asc' ? 1 : -1;
        } else {
          return 0;
        }
      });
    } else if (col === 'message') {
      this.userData = this.userData.sort((a, b) => {
        if (a.message < b.message) {
          return event.orderBy === 'asc' ? -1 : 1;
        } else if (a.message > b.message)  {
          return event.orderBy === 'asc' ? 1 : -1;
        } else {
          return 0;
        }
      });
    } else if (col === 'createAt') {
      this.userData = this.userData.sort((a, b) => {
        if (new Date(a.createAt) < new Date(b.createAt) ) {
          return event.orderBy === 'asc' ? -1 : 1;
        } else if (new Date(a.createAt) > new Date(b.createAt) )  {
          return event.orderBy === 'asc' ? 1 : -1;
        } else {
          return 0;
        }
      });
    }
  }

  onSearch(event) {
    // tslint:disable-next-line:max-line-length
    const value = event ? event.text.toLowerCase() : null;
    const dateFromObj = event.dateFrom;
    const dateToObj = event.dateTo;
    const dateFrom = dateFromObj ? new Date(dateFromObj.year + '-' + dateFromObj.month + '-' + dateFromObj.day) : null ;
    const dateTo = dateToObj ? new Date(dateToObj.year + '-' + dateToObj.month + '-' + dateToObj.day) : null ;
    this.userData = this.rawData.filter(x =>
      ((x.firstName + x.lastName).trim().toLowerCase().indexOf(value.trim()) > -1
        || (x.phone && (x.phone).trim().toLowerCase().indexOf(value.trim()) > -1)
        || (x.email && (x.email).trim().toLowerCase().indexOf(value.trim()) > -1)
        || (x.message && (x.message).trim().toLowerCase().indexOf(value.trim()) > -1)
        || !value)
      && (((new Date(x.createdAt).setHours(0, 0, 0, 0) >= (dateFrom ? dateFrom.getTime() : null) || dateFrom == null)
          && (new Date(x.createdAt).setHours(0, 0, 0, 0) <= (dateTo ? dateTo.getTime() : null) || dateTo == null)))
      );
    this.userTotal = this.userData.length;
  }

  onDeleteAll(event: any[]) {
    const modalRef = this.modalService.open(ConfirmDialogComponent);
    modalRef.componentInstance.text = 'Are you sure to delete notification ' + event.length + ' items ?';
    modalRef.componentInstance.type = 'custom';
    modalRef.result.then((result) => {
      if (result) {
        this.contactUsService.deleteAll(event).subscribe(x => {
          this.contactUsService.getAll().subscribe((res: []) => {
            this.rawData = res;
            this.userData = res;
            this.userTotal = this.userData.length;
          });
          this.toastr.success('Delete Success');
        });
      }
    }, (reason) => {
    });
  }

}
